export const serverDefaultCfg = {
    baseURL: process.env.VUE_APP_SERVER_HOST,
    mockURL: '',
};
